import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/web/withdraw/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 提现处理
export function handleWithdraw(data) {
  return request.send({
    url: `/pmy/sys/web/withdraw/handle`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 查询提现详情
export function detailInfo(withdrawId) {
  return request.send({
    url: `/pmy/sys/web/withdraw/detail?withdrawId=${withdrawId}`,
    method: "get",
  });
}
